import { useState } from "react";
import Accordion from "../accordion/Accordion";
import Icon from "../icons/Icon";
import Layout from "../layout/Layout";

const ANIMATION_DURATION = 300;

const ContentAccordion = ({ firstContent, secondContent, className, ...props }) => {
  const [isFirstContent, setIsFirstContent] = useState(false);

  return (
    <div className={`__4 ${className}`} {...props}>
      <Accordion animationDuration={ANIMATION_DURATION} isExpanded skipInitialAnimation>
        <div
          className={`bc12 ${isFirstContent ? "content" : ""}`}
          dangerouslySetInnerHTML={{ __html: isFirstContent ? firstContent : secondContent }}
        ></div>
      </Accordion>
      <Layout
        flex
        justifyContentCenter
        alignItemsCenter
        addClass="__4c"
        clicked={() => setIsFirstContent(prev => !prev)}
      >
        <Icon
          iconId="arrowDown"
          style={{
            transitionProperty: "transform",
            transform: isFirstContent ? undefined : "rotate(180deg)",
            transitionDuration: `${ANIMATION_DURATION}ms`,
          }}
        />
      </Layout>
    </div>
  );
};

export default ContentAccordion;
